// App.js
import React from 'react';
import AppointmentForm from './appointments_form'; // Adjust the import path as necessary
import './appointments.css'; // Make sure to import your CSS file

import Header from "./header_cont";
import "./App.css";

import ContactSection from './contacts_section';
import './contact_form.css';

import FAQSection from "./FAQsection";

import AboutUs from './about_me';
import "./about_me.css";

import ReviewsSlider from "./review_slider";

import Footer from './footer';

import BannerSlideshow from "./banner_slideshow";

import WeRepairSection from './we_repair_section';

function App() {
  return (
    <div>
      {/* The fixed header at top */}
      <Header />

      <BannerSlideshow />

      {/* The rest of the page content. We push it down so it's not hidden by the header */}
      <div className="main-content">
        {/* Show the form as part of the page (with banner, etc.). */}
        <AppointmentForm isModal={false} />
      </div>

      <div className="about-me-section" id="about-me">
        <AboutUs />
      </div>

      <div className="reviews-section" id="reviews">
        <ReviewsSlider />
      </div>

      <div className="faq-section" id="faq">
        <FAQSection />
      </div>

      <div className="we-repair-section" id="we-repair">
        <WeRepairSection />
      </div>

      <div className="contacts" id="call-me-section">
        <ContactSection />
      </div>

      <div className='footer-section'>
        <Footer />
      </div>

    </div>
  );
}

export default App;
